// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Header button back */

.help-desk-messenger-back-button, .help-desk-messenger-back-button * {
  cursor: pointer;
}

.help-desk-messenger-back-button {
  /*z-index: 2147483000;*/
  position: absolute;
  width: 51px;
  height: 51px;
  top: 0px;
  left: 0px;
  background-position: center center;
  margin: 12px 2px 12px 8px;
}

.help-desk-messenger-back-button-wrapper {
  width: 51px;
  height: 51px;
  box-sizing: border-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  transform: translateZ(0px);
  padding: 8px;
  margin: 0px auto;
  border-radius: 8px;
}

.help-desk-messenger-back-button-svg {
  width: 9px;
  height: 15px;
  margin: 0px auto;
}

:not(svg) {
  transform-origin: 0px 0px;
}

.help-desk-messenger-back-button-svg > g > g {
  fill: rgb(255, 255, 255);
}

/* Header Close */

.help-desk-close-header-button, .help-desk-close-header-button * {
  cursor: pointer;
}

.help-desk-close-header-button {
  z-index: 2147483003;
  position: absolute;
  width: 51px;
  height: 51px;
  top: 0px;
  right: 0px;
  background-position: center center;
  margin: 12px 8px 12px 2px;
}

.help-desk-close-button-svg {
  width: 51px;
  height: 51px;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  transform: translateZ(0px);
  margin: 0px auto;
  border-radius: 8px;
}

/* Header main */

.help-desk-avatar-wrapper {
  box-sizing: border-box;
  padding: 30px 30px 30px 75px;
}

.help-desk-avatar-header {
  display: table-cell;
  position: relative;
}

  .help-desk-avatar-header .help-desk-avatar-image {
    display: inline-block;
    vertical-align: middle;
    width: 60px;
    height: 60px;
    line-height: 60px;
    font-size: 30px;
    margin: 0px auto;
    border-radius: 50%;
    background-color: #fafafa;
    padding: 5px;
  }

    .help-desk-avatar-header .help-desk-avatar-image img {
      width: 60px;
      height: 60px;
    }

    .help-desk-avatar-header .help-desk-avatar-image img {
        border-radius: 50%;
    }

.help-desk-avatar-header .help-desk-support-active {
  width: 8px;
  height: 8px;
  background-color: rgb(126, 211, 33);
  display: inline-block;
  vertical-align: bottom;
  right: 3px;
  bottom: 3px;
  position: absolute;
  border-width: 2px;
  border-style: solid;
  border-color: rgb(126, 211, 33);
  border-image: initial;
  margin: 0px auto;
  border-radius: 50%;
}

.help-desk-avatar-header .help-desk-support-no-active {
  width: 8px;
  height: 8px;
  background-color: rgb(167, 4, 66);
  display: inline-block;
  vertical-align: bottom;
  right: 3px;
  bottom: 3px;
  position: absolute;
  border-width: 2px;
  border-style: solid;
  border-color: rgb(167, 4, 66);
  border-image: initial;
  margin: 0px auto;
  border-radius: 50%;
}

.help-desk-support-info {
  display: table-cell;
  vertical-align: top;
  padding-top: 16px;
  padding-left: 20px;
}

  .help-desk-support-info .help-desk-support-name {
    color: rgb(255, 255, 255);
    font-size: 17px;
    line-height: 1.5em;
    white-space: nowrap;
    width: 190px;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .help-desk-support-info .help-desk-support-status {
    color: rgba(255, 255, 255, 0.7);
    font-size: 13px;
    line-height: 1.5em;
    white-space: nowrap;
    width: 190px;
    text-overflow: ellipsis;
    overflow: hidden;
}

.help-desk-support-location {
    margin-top: 18px;
    line-height: 1.4;
}

  .help-desk-support-location .help-desk-support-location-wrapper {
    color: rgb(255, 255, 255);
    font-size: 13px;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-bottom: 5px;
    overflow: hidden;
  }

  .help-desk-support-location .help-desk-support-location-wrapper .help-desk-support-location-svg {
      width: 16px;
      height: 16px;
      margin-right: 5px;
      margin-left: 5px;
      vertical-align: top;
  }

  .help-desk-support-location .help-desk-support-location-wrapper .help-desk-support-location-svg > g > g {
    stroke: rgb(255, 255, 255);
  }

  .help-desk-support-location .help-desk-support-location-wrapper .help-desk-support-location-svg > g > g path {
    fill: #ffffff;
  }`, "",{"version":3,"sources":["webpack://./dist/src/components/layout/header/header-chat/header-chat.css"],"names":[],"mappings":";AACA,uBAAuB;;AAEvB;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,iBAAiB;;AAEjB;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,UAAU;EACV,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,gBAAgB;;AAEhB;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;EAEE;IACE,qBAAqB;IACrB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;EACd;;IAEE;MACE,WAAW;MACX,YAAY;IACd;;IAEA;QACI,kBAAkB;IACtB;;AAEJ;EACE,UAAU;EACV,WAAW;EACX,mCAAmC;EACnC,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;EAEE;IACE,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,+BAA+B;IAC/B,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;EAEE;IACE,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;MACI,WAAW;MACX,YAAY;MACZ,iBAAiB;MACjB,gBAAgB;MAChB,mBAAmB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf","sourcesContent":["\r\n/* Header button back */\r\n\r\n.help-desk-messenger-back-button, .help-desk-messenger-back-button * {\r\n  cursor: pointer;\r\n}\r\n\r\n.help-desk-messenger-back-button {\r\n  /*z-index: 2147483000;*/\r\n  position: absolute;\r\n  width: 51px;\r\n  height: 51px;\r\n  top: 0px;\r\n  left: 0px;\r\n  background-position: center center;\r\n  margin: 12px 2px 12px 8px;\r\n}\r\n\r\n.help-desk-messenger-back-button-wrapper {\r\n  width: 51px;\r\n  height: 51px;\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n  align-items: center;\r\n  transform: translateZ(0px);\r\n  padding: 8px;\r\n  margin: 0px auto;\r\n  border-radius: 8px;\r\n}\r\n\r\n.help-desk-messenger-back-button-svg {\r\n  width: 9px;\r\n  height: 15px;\r\n  margin: 0px auto;\r\n}\r\n\r\n:not(svg) {\r\n  transform-origin: 0px 0px;\r\n}\r\n\r\n.help-desk-messenger-back-button-svg > g > g {\r\n  fill: rgb(255, 255, 255);\r\n}\r\n\r\n/* Header Close */\r\n\r\n.help-desk-close-header-button, .help-desk-close-header-button * {\r\n  cursor: pointer;\r\n}\r\n\r\n.help-desk-close-header-button {\r\n  z-index: 2147483003;\r\n  position: absolute;\r\n  width: 51px;\r\n  height: 51px;\r\n  top: 0px;\r\n  right: 0px;\r\n  background-position: center center;\r\n  margin: 12px 8px 12px 2px;\r\n}\r\n\r\n.help-desk-close-button-svg {\r\n  width: 51px;\r\n  height: 51px;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n  align-items: center;\r\n  -webkit-box-pack: center;\r\n  justify-content: center;\r\n  transform: translateZ(0px);\r\n  margin: 0px auto;\r\n  border-radius: 8px;\r\n}\r\n\r\n/* Header main */\r\n\r\n.help-desk-avatar-wrapper {\r\n  box-sizing: border-box;\r\n  padding: 30px 30px 30px 75px;\r\n}\r\n\r\n.help-desk-avatar-header {\r\n  display: table-cell;\r\n  position: relative;\r\n}\r\n\r\n  .help-desk-avatar-header .help-desk-avatar-image {\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n    width: 60px;\r\n    height: 60px;\r\n    line-height: 60px;\r\n    font-size: 30px;\r\n    margin: 0px auto;\r\n    border-radius: 50%;\r\n    background-color: #fafafa;\r\n    padding: 5px;\r\n  }\r\n\r\n    .help-desk-avatar-header .help-desk-avatar-image img {\r\n      width: 60px;\r\n      height: 60px;\r\n    }\r\n\r\n    .help-desk-avatar-header .help-desk-avatar-image img {\r\n        border-radius: 50%;\r\n    }\r\n\r\n.help-desk-avatar-header .help-desk-support-active {\r\n  width: 8px;\r\n  height: 8px;\r\n  background-color: rgb(126, 211, 33);\r\n  display: inline-block;\r\n  vertical-align: bottom;\r\n  right: 3px;\r\n  bottom: 3px;\r\n  position: absolute;\r\n  border-width: 2px;\r\n  border-style: solid;\r\n  border-color: rgb(126, 211, 33);\r\n  border-image: initial;\r\n  margin: 0px auto;\r\n  border-radius: 50%;\r\n}\r\n\r\n.help-desk-avatar-header .help-desk-support-no-active {\r\n  width: 8px;\r\n  height: 8px;\r\n  background-color: rgb(167, 4, 66);\r\n  display: inline-block;\r\n  vertical-align: bottom;\r\n  right: 3px;\r\n  bottom: 3px;\r\n  position: absolute;\r\n  border-width: 2px;\r\n  border-style: solid;\r\n  border-color: rgb(167, 4, 66);\r\n  border-image: initial;\r\n  margin: 0px auto;\r\n  border-radius: 50%;\r\n}\r\n\r\n.help-desk-support-info {\r\n  display: table-cell;\r\n  vertical-align: top;\r\n  padding-top: 16px;\r\n  padding-left: 20px;\r\n}\r\n\r\n  .help-desk-support-info .help-desk-support-name {\r\n    color: rgb(255, 255, 255);\r\n    font-size: 17px;\r\n    line-height: 1.5em;\r\n    white-space: nowrap;\r\n    width: 190px;\r\n    text-overflow: ellipsis;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .help-desk-support-info .help-desk-support-status {\r\n    color: rgba(255, 255, 255, 0.7);\r\n    font-size: 13px;\r\n    line-height: 1.5em;\r\n    white-space: nowrap;\r\n    width: 190px;\r\n    text-overflow: ellipsis;\r\n    overflow: hidden;\r\n}\r\n\r\n.help-desk-support-location {\r\n    margin-top: 18px;\r\n    line-height: 1.4;\r\n}\r\n\r\n  .help-desk-support-location .help-desk-support-location-wrapper {\r\n    color: rgb(255, 255, 255);\r\n    font-size: 13px;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n    margin-bottom: 5px;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .help-desk-support-location .help-desk-support-location-wrapper .help-desk-support-location-svg {\r\n      width: 16px;\r\n      height: 16px;\r\n      margin-right: 5px;\r\n      margin-left: 5px;\r\n      vertical-align: top;\r\n  }\r\n\r\n  .help-desk-support-location .help-desk-support-location-wrapper .help-desk-support-location-svg > g > g {\r\n    stroke: rgb(255, 255, 255);\r\n  }\r\n\r\n  .help-desk-support-location .help-desk-support-location-wrapper .help-desk-support-location-svg > g > g path {\r\n    fill: #ffffff;\r\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
